import { fetchRelatedStartups } from 'features/innovations/business/Startup.api';
import { InnovationContext } from 'pages/les-innovations/[slug]';
import React, { ComponentPropsWithRef, FC, useContext, useMemo } from 'react';
import { usePlcApiCall } from '@api/business/api.hook';
import { ContentCardLoader } from '@components/content/ContentCard/ContentCardLoader.component';
import { Text } from '@components/Text/Text.component';
import { buildStartupCard } from '@utils/card';
import classNames from 'classnames';

import './InnovationDetailSimilaire.scss';

type Props = ComponentPropsWithRef<'main'> & {};

export const InnovationDetailSimilaire: FC<Props> = ({ className }) => {
  const rootClass = classNames('grid-m-3-s-1 white', className);
  const {
    startup: { data: startup },
    domains: { data: domainsList },
    stakes: { data: stakesList },
    sectors: { data: sectorsList },
  } = useContext(InnovationContext);
  // Recall with dedumping
  const { data, isValidating } = usePlcApiCall(fetchRelatedStartups, [startup?.slug ?? ''], {});

  const startupsList = useMemo(() => {
    return (data || []).map(item => buildStartupCard(item, domainsList ?? [], stakesList ?? [], sectorsList ?? []));
  }, [data]);

  if (isValidating) {
    return (
      <div className={rootClass}>
        <>
          <ContentCardLoader uniqueKey="InnovationDetailSimilaire1" />
          <ContentCardLoader uniqueKey="InnovationDetailSimilaire2" />
          <ContentCardLoader uniqueKey="InnovationDetailSimilaire3" />
        </>
      </div>
    );
  }
  if (!startupsList || startupsList.length === 0) {
    return null;
  }

  return (
    <div className="background-ultralight">
      <div className="wrapper-s">
        <Text className="h2-up-s plc-pt-m" i18nKey="innovations.detail.startup.similaire" tag="h2" variant="h3" />
        <div className={rootClass}>{startupsList.slice(0, 3)}</div>
      </div>
    </div>
  );
};
